module.exports = __webpack_public_path__ + "static/ss2.089dba5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tb/ss2.png
// module id = 1207
// module chunks = 277036769636407